"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.StyledFileLoaderItem = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
var _Close = _interopRequireDefault(require("../../../../icons-react/Close"));
var _Throbber = _interopRequireDefault(require("../../../Throbber"));
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var FileLoaderItem = function FileLoaderItem(props) {
  var _props$className = props.className,
    className = _props$className === void 0 ? '' : _props$className,
    _props$text = props.text,
    text = _props$text === void 0 ? '' : _props$text,
    _props$isLoading = props.isLoading,
    isLoading = _props$isLoading === void 0 ? false : _props$isLoading,
    _props$isMobile = props.isMobile,
    isMobile = _props$isMobile === void 0 ? false : _props$isMobile,
    _props$onRemoveClick = props.onRemoveClick,
    onRemoveClick = _props$onRemoveClick === void 0 ? Function.prototype : _props$onRemoveClick;
  return /*#__PURE__*/_react["default"].createElement(StyledFileLoaderItem, {
    className: className,
    isMobile: isMobile
  }, /*#__PURE__*/_react["default"].createElement(StyledFileText, null, text), isLoading ? /*#__PURE__*/_react["default"].createElement(StyledTrobberWrapper, null, /*#__PURE__*/_react["default"].createElement(_Throbber["default"], {
    size: 10,
    color: "#007aff",
    embed: true
  })) : /*#__PURE__*/_react["default"].createElement(StyledIconWrapper, {
    onClick: function onClick() {
      return onRemoveClick();
    }
  }, /*#__PURE__*/_react["default"].createElement(StyledCloseIcon, null)));
};
var StyledFileLoaderItem = exports.StyledFileLoaderItem = _styledComponents["default"].div.withConfig({
  displayName: "FileLoaderItem__StyledFileLoaderItem",
  componentId: "sc-aq14se-0"
})(["display:flex;flex-direction:row;align-items:center;background:#e6f2ff;border-radius:4px;padding:8px;", " ", ""], function (_ref) {
  var isMobile = _ref.isMobile;
  return isMobile ? "max-width: 100%;" : 'max-width: 220px;';
}, function (_ref2) {
  var isMobile = _ref2.isMobile;
  return isMobile ? "margin-top: 8px;" : null;
});
var StyledFileText = _styledComponents["default"].div.withConfig({
  displayName: "FileLoaderItem__StyledFileText",
  componentId: "sc-aq14se-1"
})(["font-size:14px;line-height:16px;color:#007aff;overflow:hidden;white-space:nowrap;text-overflow:ellipsis;"]);
var StyledCloseIcon = (0, _styledComponents["default"])(_Close["default"]).withConfig({
  displayName: "FileLoaderItem__StyledCloseIcon",
  componentId: "sc-aq14se-2"
})(["height:12px;width:12px;path{transition:opacity 200ms;stroke:#007aff;}"]);
var StyledAppendWrapper = (0, _styledComponents.css)(["display:flex;align-items:center;justify-content:center;padding:4px;margin-left:10px;"]);
var StyledTrobberWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FileLoaderItem__StyledTrobberWrapper",
  componentId: "sc-aq14se-3"
})(["", ""], StyledAppendWrapper);
var StyledIconWrapper = _styledComponents["default"].div.withConfig({
  displayName: "FileLoaderItem__StyledIconWrapper",
  componentId: "sc-aq14se-4"
})(["", " cursor:pointer;:hover{", "{path{opacity:0.7;}}}"], StyledAppendWrapper, StyledCloseIcon);
var _default = exports["default"] = FileLoaderItem;